export default "__VITE_ASSET__DhxTigDy__"